import { render, staticRenderFns } from "./DailyFaultStatsOfArea.vue?vue&type=template&id=1752c984&"
import script from "./DailyFaultStatsOfArea.script.js?vue&type=script&lang=js&"
export * from "./DailyFaultStatsOfArea.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports